import styled from 'styled-components';
import { Button } from 'antd';

export const BtnContinuarAgendamento = styled(Button)`
  @media (max-width: 768px) {
    color: #fff;
    background: #1890ff;
    border-color: #1890ff;
    text-shadow: 0 -1px 0 rgb(0 0 0 / 12%);
    -webkit-box-shadow: 0 2px 0 rgb(0 0 0 / 5%);
    box-shadow: 0 2px 0 rgb(0 0 0 / 5%);
    margin-bottom: 1em;
  }
`;
export const ModalContainer = styled.div`
  padding-bottom: 10px;
  h2 {
    color: #096dd9;
    font-weight: 400;
    font-size: 20px;
  }
  .ant-radio-button-wrapper {
    margin-right: 10px;
    margin-bottom: 20px;
    font-weight: 500;
    font-size: 16px;
  }
  .ant-radio-button-wrapper:hover {
    color: #fff;
    background: #1890ff;
    border-color: #1890ff;
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    color: #fff;
    background: #1890ff;
    border-color: #1890ff;
  }
  .info {
    background-color: #fffdf5;
    border: solid 2px #fff1b8;
    padding: 1rem 0.5rem;
    display: block;
    margin-top: 3rem;
  }
  p {
    font-size: 14px;
    color: #8c8c8c;
  }
  .searchBtn {
    margin-left: 10px;
  }

  .labelFilter {
    font-size: 16px;
    margin-bottom: 5px;
    font-weight: 600;
  }
`;

export const FiltroTitulo = styled.div`
  font-size: 16px;
  font-family: roboto, serif;
  font-weight: 500;
`;

export const Plataforma = styled.div`
  width: 100%;
  border-radius: 5px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #71717a;
  text-align: center;
  margin: 1rem auto;
  padding: 10px;
`;
